import { NavLink, Outlet, Navigate } from 'react-router-dom';
import { useMerchantAuth } from '../../../contexts/AuthContext';

export default function StaffLayout() {
    const { hasPermission } = useMerchantAuth();
    const tabs = [
        { name: 'Staff', path: '/dashboard/staff', permission: 'view_staff' },
        { name: 'Roles', path: '/dashboard/staff/roles', permission: 'view_roles' },
    ].filter((t) => hasPermission(t.permission));

    if (tabs.length === 0) {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <div className="min-h-screen bg-gray-300 p-4 sm:p-8">
            <div className="max-w-5xl mx-auto">
                <div className="mb-6 flex flex-wrap items-center justify-between gap-2 sm:gap-4 border-b pb-4">
                    <div className="flex flex-wrap gap-2 sm:gap-4">
                        {tabs.map((tab) => (
                            <NavLink
                                key={tab.name}
                                to={tab.path}
                                end={tab.path === '/dashboard/staff'}
                                className={({ isActive }) =>
                                    `px-3 py-2 text-sm sm:text-md font-semibold ${
                                        isActive
                                            ? 'border-b-2 border-primary text-primary'
                                            : 'text-gray-500 hover:text-dark'
                                    }`
                                }
                            >
                                {tab.name}
                            </NavLink>
                        ))}
                    </div>
                </div>
                <Outlet />
            </div>
        </div>
    );
}
